module.exports = __webpack_public_path__ + "media/images/job-inventory-transparent-logo-c9b81942f1be768b448aa022762a67af.png";